/**
 * Authenticated fetch for user-scoped API routes (Phase 0 Task 0.6).
 * Sends Cognito access token, silently refreshes before expiry, and retries once on 401.
 */

import {
  getAccessToken,
  ensureFreshAccessToken,
  refreshAuthTokens,
  clearAuthSession,
  redirectToLogin,
  isAuthenticated,
} from './authTokens';

export {
  getAccessToken,
  clearAuthSession,
  redirectToLogin,
  isAuthenticated,
};

export function getAuthHeaders(extraHeaders = {}) {
  const headers = { ...extraHeaders };
  const token = getAccessToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

export async function authFetch(url, options = {}, retried = false) {
  await ensureFreshAccessToken();

  const headers = getAuthHeaders(options.headers || {});
  const response = await fetch(url, { ...options, headers });

  if (response.status === 401 && !retried) {
    const refreshed = await refreshAuthTokens();
    if (refreshed) {
      return authFetch(url, options, true);
    }
    redirectToLogin();
  } else if (response.status === 401) {
    redirectToLogin();
  }

  return response;
}
